// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Yp-z","breadcrumbForward":"Zp-z","breadcrumbBack":"_p-z","selected":"aq-z"};